import React from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';

const Navigation = () => {
    const { contentLinks, newsLink, offerLink, myPageLink, logoutLink, textColor, buttonColor, buttonTextColor, channelName } = useSelector((state) => state.navigation);

    return <NavigationItem
        links={contentLinks}
        newsLink={newsLink}
        offerLink={offerLink}
        myPageLink={myPageLink}
        logoutLink={logoutLink}
        textColor={textColor}
        buttonColor={buttonColor}
        buttonTextColor={buttonTextColor}
        channelName={channelName}
    />;
};

export default Navigation;
